const generateHeaders = (otherObj) => {
  return {
    handleDefaultError: otherObj?.handleDefaultError || false,
    handle401: otherObj?.handle401 || false,
    handle500: otherObj?.handle500 || false,
  };
};

const commonAPI = {
  getFavoriteAPI: (instance, getData) => instance.get(API_URL.FAVORITE, getData),
  postFavoriteAPI: (instance, postData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.post(API_URL.FAVORITE, postData, { headers });
  },
  deleteFavoriteAPI: (instance, deleteData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.delete(API_URL.FAVORITE, { ...deleteData, headers });
  },
  getHotSearchAPI: (instance, getData) => instance.get(API_URL.HOT_SEARCH, getData),
  getCartInfoAPI: (instance) => instance.get(API_URL.CART_INFO),
  getShareAPI: (instance, id) => instance.get(`${API_URL.SHARE}/${id}`),
  postNewsletter: (instance, postData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.post(API_URL.NEWSLETTER, postData, { headers });
  },
};

const articleAPI = {
  getArticleListAPI: (instance, getData) => instance.get(API_URL.ARTICLE_LIST, getData),
  getArticleContentAPI: (instance, id, getData) =>
    instance.get(`${API_URL.ARTICLE_CONTENT}/${id}`, getData),
  getArticleCategoryAPI: (instance, id, getData) => instance.get(API_URL.ARTICLE_CATEGORY, getData),
};

const addonAPI = {
  getAddonCartAPI: (instance, getData) => instance.get(API_URL.ADDON_CART, getData),
  getAddonEvent: (instance, getData) => instance.get(API_URL.ADDON_EVENT, getData),
};

const brandAPI = {
  getBrandFollowAPI: (instance) => instance.get(API_URL.BRAND),
  postBrandFollowAPI: (instance, postData) => instance.post(API_URL.BRAND_FOLLOW, postData),
  deleteBrandFollowAPI: (instance, deleteData) => instance.delete(API_URL.BRAND_FOLLOW, deleteData),
};

const cartAPI = {
  postCouponAPI: (instance, postData) => instance.post(API_URL.COUPON, postData),
  postCoupon2API: (instance, postData) => instance.post(API_URL.COUPON2, postData),
  getOrderAddressAPI: (instance, getData) => instance.get(API_URL.ORDER_ADDRESS, getData),
  postShoppingCartAPI: (instance, postData) => instance.post(API_URL.SHOPPING_CART, postData),
  getShoppingCartAPI: (instance, getData) => instance.get(API_URL.SHOPPING_CART, getData),
  putShoppingCartAPI: (instance, putData) => instance.put(API_URL.SHOPPING_CART, putData),
  getAddressBookAPI: (instance, getData) => instance.get(API_URL.ADDRESS_BOOK, getData),
  deleteAddressBookAPI: (instance, id) => instance.delete(`${API_URL.ADDRESS_BOOK}/${id}`),
  postAddressBookAPI: (instance, postData) => instance.post(API_URL.ADDRESS_BOOK, postData),
  getLastInvoiceAPI: (instance, getData) => instance.get(API_URL.LAST_INVOICE_SETTING, getData),
  getVerifyMobileCode: (instance, getData) => instance.get(API_URL.VERIFY_MOBILE_CODE, getData),
  getCartRecommendDataAPI: (instance, getData) => instance.get(API_URL.RECOMMEND_CART, getData),
};

const shopAPI = {
  getSearchRecommendAPI: (instance, getData) => instance.get(API_URL.MARKET_NEW, getData),
  getSortConditionAPI: (instance) => instance.get(API_URL.SORT_POPUP),
  getDataAPI: (instance, getData) => instance.get(API_URL.MARKET_CONTENT, getData),
  getSeriesDataAPI: (instance, getData) => instance.get(API_URL.SERIES_MARKET_CONTENT, getData),
  getBrandRecommendDataAPI: (instance, getData) => instance.get(API_URL.MARKET_RECOMMEND, getData),
  getRecommendDataAPI: (instance, getData) => instance.get(API_URL.MARKET_RECOMMEND, getData),
  getMarketRecommendDataAPI: (instance, getData) => instance.get(API_URL.RECOMMEND_SHOP, getData),
  postNoticeAPI: (instance, postData) => instance.post(API_URL.IN_STOCK_EMAIL, postData),
  getStockDataApi: (instance, getData) => instance.get(API_URL.STOCK, getData),
};

const loginAPI = {
  postForgetPS: (instance, postData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.post(API_URL.FORGET_PS, postData, { headers });
  },
  getAccountExist: (instance, getData) => instance.get(API_URL.ACCOUNT_EXIST, getData),
};

const orderAPI = {
  deleteOrderAPI: (instance, deleteData) => instance.delete(API_URL.ORDER, deleteData),
  getRefundDetailAPI: (instance, getData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.get(API_URL.REFUND_DETAIL, { ...getData, headers });
  },
  getOrderAPI: (instance, getData) => instance.get(API_URL.ORDER, getData),
  postRefundCalculateAPI: (instance, postData) => instance.post(API_URL.REFUND_CALCULATE, postData),
  getShippingFlowAPI: (instance, getData) => instance.get(API_URL.SHIPPING_FLOW, getData),
  getOrderAtmAPI: (instance, getData) => instance.get(API_URL.ORDER_ATM, getData),
  postCashInAPI: (instance, postData) => instance.post(API_URL.VC_CASH_IN, postData),
};

const memberAPI = {
  // urliving 5%驗證
  getVerifyPhoneAPI: (instance, getData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.get(API_URL.VERIFY_PHONE, { ...getData, headers });
  },
  // 取回饋金歷程
  getBonusRecordAPI: (instance, getData) => instance.get(API_URL.BONUS_RECORDS, getData),
  // 提領回饋金
  postBonusWithDrawAPI: (instance, postData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.post(API_URL.BONUS_WITHDRAW, postData, { headers });
  },
  // 上傳身分證
  postUserIdAPI: (instance, postData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.post(API_URL.USER_IDENTIFICATION, postData, { headers });
  },
  // 回饋金-綁定銀行帳號
  postUserBankAccountAPI: (instance, postData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.post(API_URL.USER_BANK_ACCOUNT, postData, { headers });
  },
  getDataAnalyzeAPI: (instance, getData) => instance.get(API_URL.DATA_ANALYZE, getData),
};

const faPointAPI = {
  getVerifyFaPointAPI: (instance, getData, otherObj) => {
    const headers = generateHeaders(otherObj);
    return instance.get(API_URL.VERIFY_FA_POINTS, { ...getData, headers });
  },
  getFaPointAPI: (instance) => instance.get(API_URL.FA_POINTS),
  postUnbindFaPointAPI: (instance) => instance.post(API_URL.UNBIND_FA_POINTS),
};

const apiCalls = {
  ...commonAPI,
  ...articleAPI,
  ...addonAPI,
  ...brandAPI,
  ...cartAPI,
  ...shopAPI,
  ...loginAPI,
  ...orderAPI,
  ...memberAPI,
  ...faPointAPI,
};

const createApi = (instance) => {
  const api = {};
  for (const [key, func] of Object.entries(apiCalls)) {
    api[key] = (...args) => func(instance, ...args);
  }
  return api;
};

export default createApi;
